import { useEffect, useState } from "react";

const navLinks = [
  { label: "导言", href: "#concept" },
  { label: "地域图谱", href: "#regions" },
  { label: "各国详解", href: "#france" },
  { label: "主题母题", href: "#themes" },
  { label: "常见问答", href: "#faq" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2.5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-base md:text-lg font-bold tracking-wide text-foreground-950">
            欧美伦理电影
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="px-3.5 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开导航菜单"
          aria-expanded={open}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200">
          <ul className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-md cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}